import { create } from 'zustand';
import { getWeekStart } from '@/lib/dates';

type CalendarView = 'week' | 'month';

interface UiState {
  selectedWeekStart: Date;
  view: CalendarView;
  toast: { id: number; message: string; tone: 'info' | 'success' | 'error' } | null;
  setSelectedWeekStart: (d: Date) => void;
  navigateWeek: (direction: 'prev' | 'next' | 'today') => void;
  setView: (v: CalendarView) => void;
  showToast: (message: string, tone?: 'info' | 'success' | 'error') => void;
  dismissToast: () => void;
}

let toastSeq = 0;

export const useUiStore = create<UiState>((set, get) => ({
  selectedWeekStart: getWeekStart(new Date()),
  view: 'week',
  toast: null,

  setSelectedWeekStart: (d) => set({ selectedWeekStart: getWeekStart(d) }),

  navigateWeek: (direction) => {
    if (direction === 'today') {
      set({ selectedWeekStart: getWeekStart(new Date()) });
      return;
    }
    const current = get().selectedWeekStart;
    const delta = direction === 'next' ? 7 : -7;
    const next = new Date(current.getTime() + delta * 24 * 60 * 60 * 1000);
    set({ selectedWeekStart: getWeekStart(next) });
  },

  setView: (v) => set({ view: v }),

  showToast: (message, tone = 'info') => {
    toastSeq += 1;
    const id = toastSeq;
    set({ toast: { id, message, tone } });
    window.setTimeout(() => {
      if (get().toast?.id === id) set({ toast: null });
    }, 3500);
  },

  dismissToast: () => set({ toast: null }),
}));
